<!--
  @Author: MiYongLe
  @Desc: 登录页面
  @Date: 2023-04-28
-->
<template>
  <div class="login-bg">
    <div class="main-block">
      <!-- 动图 -->
      <div class="img-block">
        <!-- 左边图片 && 投影 -->
        <div class="img-left">
          <div class="item-left-one">
            <img src="./../../../static/login/login_float1.png" alt="慧用工" />
            <img src="./../../../static/login/login_float5.png" alt="慧用工" />
          </div>
          <div class="item-left-two">
            <img src="./../../../static/login/login_float2.png" alt="慧用工" />
            <img src="./../../../static/login/login_float6.png" alt="慧用工" />
          </div>
        </div>

        <!-- 中间慧用工大图 -->
        <div class="img-center">
          <img src="./../../../static/login/login_face3.png" alt="慧用工" />
          <img src="./../../../static/login/login_face2.png" alt="慧用工" />
          <img
            v-if="notOemList.includes(hostname)"
            src="./../../../static/login/login_face1.png"
            alt="慧用工"
          />
          <img
            v-else
            src="./../../../static/login/login_oem.png"
            alt="慧用工"
          />
          <img src="./../../../static/login/login_float4.png" alt="慧用工" />
        </div>

        <!-- 右上图片 -->
        <div class="img-right">
          <img src="./../../../static/login/login_float3.png" alt="慧用工" />
          <img src="./../../../static/login/login_float3.png" alt="慧用工" />
        </div>
      </div>

      <!-- 表单 -->
      <div class="form-block">
        <!-- logo -->
        <div class="form-img-box">
          <img
            :src="resOemInfo.webHomeLogo"
            alt=""
            v-if="resOemInfo.webHomeLogo"
          />
        </div>

        <!-- tab -->
        <div class="tab-block">
          <!-- tab切换 -->
          <div class="tab-item">
            <span :class="{ activeName: itemIndex === 0 }" @click="tabClick(0)"
              >账号登录</span
            >
            <span :class="{ activeName: itemIndex === 1 }" @click="tabClick(1)"
              >免密登录</span
            >
          </div>

          <div class="form-con">
            <!-- 账号登录 -->
            <div v-if="itemIndex === 0" id="loginBlock">
              <el-form
                :model="accountAndPwdParam"
                :rules="rulesAccountAndPwd"
                ref="accountAndPwdParam"
              >
                <el-form-item class="login-form-item" prop="loginName">
                  <el-input
                    placeholder="请输入账号"
                    v-model="accountAndPwdParam.loginName"
                  >
                    <div slot="prefix" class="icon-block">
                      <img
                        src="../../../static/login/ic_login_account.png"
                        alt="慧用工"
                      />
                    </div>
                  </el-input>
                </el-form-item>
                <el-form-item class="login-form-item" prop="passWord">
                  <p class="password-style">
                    <!-- show-password -->
                    <el-input
                      placeholder="请输入密码"
                      v-model="accountAndPwdParam.passWord"
                      type="password"
                    >
                      <div slot="prefix" class="icon-block">
                        <img
                          src="../../../static/login/ic_login_password.png"
                          alt="慧用工"
                        />
                      </div>
                    </el-input>
                  </p>
                </el-form-item>
                <div class="find-password" >
                  <span class="btnNoBordeShortrBlue" @click="xhrFindPwd()">找回密码</span>
                </div>
                <!-- 网易易盾 -->
                <div
                  id="captchaAccountNumber"
                  v-if="defaultSwitch.isShowAccountNumberNetEase"
                ></div>

                <el-form-item
                  class="login-form-item"
                  v-if="defaultSwitch.isShowAccountNumberNetEase"
                >
                  <el-input
                    placeholder=""
                    v-model="accountAndPwdParam.mobileSecretTelNo"
                    :maxlength="11"
                    :disabled="true"
                  >
                    <div slot="prefix" class="icon-block">
                      <img
                        src="../../../static/login/icon_login_phone.png"
                        alt="慧用工"
                      />
                    </div>
                  </el-input>
                </el-form-item>

                <!-- 获取登陆验证码 -->
                <el-form-item
                  class="form-item-password"
                  prop="smsCode"
                  v-if="defaultSwitch.getCodeVisible"
                >
                  <div class="password-block">
                    <el-input
                      placeholder="请输入验证码"
                      v-model="accountAndPwdParam.smsCode"
                      :maxlength="6"
                      @input="changeCode"
                    >
                      <div slot="prefix" class="icon-block">
                        <img
                          src="../../../static/login/icon_login_code.png"
                          alt="慧用工"
                        />
                      </div>
                    </el-input>
                  </div>
                  <span
                    class="btnLargeLineColor btnHeight40"
                    @click="getCodeOpera"
                    >{{ defaultSwitch.getCodeText }}</span
                  >
                </el-form-item>
              </el-form>
              <div
                class="login-btn"
                @click="xhrAccountLogin('accountAndPwdParam')"
              >
                {{ defaultSwitch.isShowAccountNumberNetEase ? "验证" : "登录" }}
              </div>
            </div>

            <!-- 免密登录 -->
            <div v-if="itemIndex === 1" id="loginBlock">
              <el-form
                :model="codeLoginParam"
                :rules="rulesCodeLogin"
                ref="codeLoginParam"
              >
                <el-form-item class="login-form-item" prop="mobile">
                  <el-input
                    placeholder="请输入手机号"
                    v-model="codeLoginParam.mobile"
                    :maxlength="11"
                  >
                    <div slot="prefix" class="icon-block">
                      <img
                        src="../../../static/login/icon_login_phone.png"
                        alt="慧用工"
                      />
                    </div>
                  </el-input>
                </el-form-item>

                <!-- 网易易盾 -->
                <div id="captcha" v-if="defaultSwitch.isShowNetEase"></div>

                <el-form-item class="form-item-password" prop="smsCode">
                  <div class="password-block">
                    <el-input
                      placeholder="请输入验证码"
                      v-model="codeLoginParam.smsCode"
                      :maxlength="6"
                      @input="changeCode"
                    >
                      <div slot="prefix" class="icon-block">
                        <img
                          src="../../../static/login/icon_login_code.png"
                          alt="慧用工"
                        />
                      </div>
                    </el-input>
                  </div>
                  <span
                    class="btnLargeLineColor btnHeight40"
                    @click="getCodeOpera"
                    >{{ defaultSwitch.getCodeText }}</span
                  >
                </el-form-item>
              </el-form>

              <el-button
                type="primary"
                class="face-density-btn"
                :loading="defaultSwitch.isDisabledBtn"
                @click="xhrCodeLogin('codeLoginParam')"
                >登录</el-button
              >
            </div>
          </div>
        </div>

        <!-- Copyright  -->
        <div class="copyright-block" v-show="resOemInfo.copyrightState">
          Copyright © {{ resOemInfo.copyright }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RULES from "../../FormVerification/index";
import { HTTP_CODE } from "../../service/axios_constants";
import { NOT_OEM_LIST } from "../../service/businessConsts";
import {
  setLocal,
  changeImgUrl,
  checkNull,
  checkPhoneNumber,
  clearLocal,
  delLocal,
  getLocal,
  checkInteger,
  getSecretTelNo
} from "../../filters/filters";
import Vue from "vue";
import {
  getNetEaseYiDunStatus,
  chineseChar2englishChar
} from "./../../filters/filters";
import { MessageBox } from "element-ui";
export default {
  name: "login",
  data() {
    return {
      itemIndex: 0,
      rulesAccountAndPwd: RULES.rulesAccountAndPwd,
      rulesCodeLogin: RULES.rulesCodeLogin,

      accountAndPwdParam: {
        loginName: "",
        passWord: "",
        mobile: "",
        smsCode: ""
      }, // 账号密码登陆

      codeLoginParam: {
        mobile: "",
        smsCode: "",
        validate: ""
      }, //手机号登录

      defaultSwitch: {
        isShowNetEase: false, //免密登陆的
        isShowAccountNumberNetEase: false, //账号登陆
        getCodeVisible: false, //验证码回显
        getCodeDisabled: false,
        getCodeText: "获取验证码",
        btnLoginStatus: false,
        isDisabledBtn: false
      }, // 默认开关
      resOemInfo: {
        webHomeLogo: ""
      }, // oem信息
      notOemList: NOT_OEM_LIST,
      hostname: window.location.hostname,
      captchaIns: null,
      timer: null
    };
  },

  created() {
    this.resOemInfo.webHomeLogo =
      window.location.hostname === "local-web.hvyogo.com"
        ? "./../../../static/login/pic_login_hyg.png"
        : "";
    this.xhrGetOemInfo();
  },

  mounted() {},

  methods: {
    // xhr -- 账号密码登陆
    xhrAccountLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            ...this.accountAndPwdParam
          };
          params.passWord = chineseChar2englishChar(params.passWord);
          if (!this.defaultSwitch.getCodeVisible) {
            this.$http.getRolesList(params).then(res => {
              if (res.statusCode === HTTP_CODE.suc) {
                this.getLoginInformation(res.data);
              } else if (res.statusCode === "200600") {
                // 200600使用验证登陆
                this.defaultSwitch.isShowAccountNumberNetEase = true;
                this.accountAndPwdParam.mobile = res.data.mobile;
                this.accountAndPwdParam.mobileSecretTelNo = getSecretTelNo(
                  res.data.mobile
                );

                this.codeLoginParam.mobile = res.data.mobile;
                this.initNetEase("#captchaAccountNumber");
              }
            });
          } else {
            if (checkNull(this.accountAndPwdParam.smsCode)) {
              MessageBox("请先获取验证码", "提示", {
                confirmButtonText: "确定",
                confirmButtonClass: "btnFullColor"
              });
              return;
            }
            delete params.mobileSecretTelNo;
            this.$http.postPrimaryAccountFirstLogin(params).then(res => {
              if (res.statusCode === HTTP_CODE.suc) {
                this.getLoginInformation(res.data);
              }
            });
          }
        }
      });
    },

    // 保存登陆信息
    getLoginInformation(data) {
      // 如果登陆人信息不一致清除缓存菜单
      if (
        !!JSON.parse(getLocal("userMessage")) &&
        JSON.parse(getLocal("userMessage")).userId != data.userId
      ) {
        delLocal("activeNavIndex");
      }
      setLocal("userMessage", JSON.stringify(data)); //将登录账号信息储存在local
      setLocal("Authorization", data.sessionToken);
      Vue.prototype.HeaderOptions = {
        Authorization: data.sessionToken
      };
      if (data.sysType === "60" || data.sysType === "70") {
        this.$router.push({ name: "index" });
        return;
      }
      this.xhrIsImproveContractInfo();
    },

    // xhr -- 是否需要补全合同信息
    xhrIsImproveContractInfo() {
      this.$http.getIsNeedCompleteContractInformation().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          // 保存商户费率类型 判断余额管理是否显示管理费退还按钮
          setLocal("computeMode", res.data.computeMode);
          if (res.data.need || res.data.signNeed || res.data.supplementarySignNeed) {
            // 这里跳转首页 清除缓存页面 强制去首页
            delLocal("activeNavIndex");
            this.$router.push({ name: "index" });
            window.location.reload();
          } else {
            //登陆成功跳转首页
            this.$router.push({ name: "index" });
            window.location.reload();
          }
        }
      });
    },

    // xhr -- 获取验证码
    xhrGetCode() {
      let param = { ...this.codeLoginParam },
        self = this;
      Reflect.deleteProperty(param, "smsCode");
      this.$http
        .postGetCode(param)
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            let getCodeTextTemp = 59;
            if (self.defaultSwitch.getCodeDisabled) {
              return;
            }
            this.timer = setInterval(() => {
              self.defaultSwitch.getCodeDisabled = true;
              self.defaultSwitch.getCodeText = getCodeTextTemp--;
              getCodeTextTemp = getCodeTextTemp--;
              self.defaultSwitch.getCodeText =
                self.defaultSwitch.getCodeText + "s";
              if (getCodeTextTemp <= 0) {
                self.defaultSwitch.getCodeText = "重新获取";
                self.defaultSwitch.getCodeDisabled = false;
                self.defaultSwitch.isShowNetEase = false;
                self.defaultSwitch.isDisabledBtn = false;
                self.defaultSwitch.isShowAccountNumberNetEase = false;
                clearInterval(this.timer);
              }
            }, 1000);
          } else {
            self.defaultSwitch.isShowNetEase = false;
          }
        })
        .catch(err => {});
    },

    // xhr - 验证码免密登录
    xhrCodeLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = { ...this.codeLoginParam };
          Reflect.deleteProperty(param, "validate");
          this.$http
            .postCodeLogin(this.codeLoginParam)
            .then(res => {
              if (res.statusCode === HTTP_CODE.suc) {
                clearLocal();
                if (!checkNull(this.resOemInfo)) {
                  setLocal("resOemInfo", this.resOemInfo);
                }
                // 跳转选择登录商户
                this.$router.push({
                  name: "select-acc",
                  query: {
                    mobile: this.codeLoginParam.mobile
                  }
                });
              }

              setTimeout(() => {
                this.defaultSwitch.isDisabledBtn = false;
              }, 1000);
            })
            .catch(err => {});
        }
      });
    },

    // xhr -- 获取oem信息
    xhrGetOemInfo() {
      this.$http.getOemInfo().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          res.data.webHomeLogo = changeImgUrl(res.data.webHomeLogo);
          res.data.webNavigationLogo = changeImgUrl(res.data.webNavigationLogo);
          this.resOemInfo = res.data;

          if (!checkNull(this.resOemInfo)) {
            setLocal("resOemInfo", this.resOemInfo);
          }
        }
      });
    },

    // 找回密码
    xhrFindPwd() {
      if(!this.accountAndPwdParam.loginName) {
        this.$message.warning('请输入账号')
        return
      }
      // 判断账号是否存在
      this.$http.postFindPwdInfo({loginName: this.accountAndPwdParam.loginName}).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.$router.push({
            path: '/findPassword',
            query: {
              account: this.accountAndPwdParam.loginName,
              phone: res.data,
            }
          });
        }
      })
      
    },


    // 设置密码
    changeCode(value) {
      if (this.itemIndex == 1) {
        if (
          value.length === 6 &&
          this.codeLoginParam.mobile &&
          checkInteger(value)
        ) {
          this.defaultSwitch.isDisabledBtn = true;
          this.xhrCodeLogin("codeLoginParam");
        }
      } else {
        if (value.length === 6) {
          this.xhrAccountLogin("accountAndPwdParam");
        }
      }
    },

    // 获取验证码
    getCodeOpera() {
      if (this.itemIndex == 1) {
        if (checkNull(this.codeLoginParam.mobile)) {
          this.$message.warning("请输入登录手机号");
          return;
        }

        if (!checkPhoneNumber(this.codeLoginParam.mobile)) {
          this.$message.warning("手机号格式不正确");
          return;
        }

        if (this.defaultSwitch.getCodeDisabled) {
          return;
        }

        if (this.defaultSwitch.getCodeText === "重新发送") {
          this.defaultSwitch.isShowNetEase = true;
          this.initNetEase("#captcha");
        }

        if (this.defaultSwitch.isShowNetEase) {
          this.$message.warning("请完成验证");
          return;
        }
        this.defaultSwitch.isShowNetEase = true;
        this.initNetEase("#captcha");
      } else {
        if (this.defaultSwitch.getCodeDisabled) {
          return;
        }
        if (this.defaultSwitch.getCodeText === "重新发送") {
          this.defaultSwitch.isShowAccountNumberNetEase = true;
          this.initNetEase("#captchaAccountNumber");
        }
        if (this.defaultSwitch.isShowAccountNumberNetEase) {
          this.$message.warning("请完成验证");
          return;
        }
        this.defaultSwitch.isShowAccountNumberNetEase = true;
        this.initNetEase("#captchaAccountNumber");
      }
    },

    // tab切换
    tabClick(index) {
      this.itemIndex = index;
      clearInterval(this.timer);
      this.defaultSwitch.getCodeText = "获取验证码";
      this.defaultSwitch.getCodeDisabled = false;
      this.defaultSwitch.btnLoginStatus = false;
      this.defaultSwitch.isDisabledBtn = false;

      if (this.itemIndex == 1) {
        this.$nextTick(() => {
          this.$refs.codeLoginParam.resetFields();
        });
        this.codeLoginParam.validate = "";
        this.defaultSwitch.isShowNetEase = false;
      } else {
        this.defaultSwitch.isShowAccountNumberNetEase = false;
        this.defaultSwitch.getCodeVisible = false;
        this.$nextTick(() => {
          this.$refs.accountAndPwdParam.resetFields();
        });
      }
    },

    // 初始化网易易盾
    initNetEase(idName) {
      const self = this;
      let captcha = idName;
      initNECaptcha(
        {
          element: captcha,
          captchaId: "2d2fc49e1af44cdc9851d14174964b69", // 网易易盾
          mode: "float",
          // apiVersion: 2,
          onVerify: (err, data) => {
            // 当验证失败时, 内部会自动 refresh 方法, 无需手动再调用一次
            if (err) return;
            // 以下为业务侧逻辑
            this.codeLoginParam.validate = data.validate;
            if (data && data.validate) {
              if (this.itemIndex === 0) {
                this.defaultSwitch.getCodeVisible = true;
              }
              this.xhrGetCode();
            }
          }
        },
        function onload(instance) {
          self.captchaIns = instance;
        },
        function onerror(err) {
          self.$message.error(getNetEaseYiDunStatus(err.code));
          self.defaultSwitch.isShowNetEase = false;
        }
      );
    }
  }
};
</script>

<style lang="scss">
#loginBlock {
  .login-form-item {
    .el-input {
      width: 360px;
      height: 40px;
      .el-input__inner {
        height: 40px;
        width: 360px;
      }
    }
    .el-input--prefix .el-input__inner {
      padding-left: 47px;
    }
  }
  .password-block {
    .el-input__inner {
      height: 40px;
      width: 256px;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 47px;
    }
  }

  .form-item-password {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../../styles/variable";

.login-bg {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("./../../../static/login/bg_login.png");
  background-repeat: no-repeat;
  position: relative;
  background-position: center center;
  background-size: auto;
  background-color: #d9e6ff;
  overflow: hidden;
  .main-block {
    width: 1440px;
    height: 563px;
    display: flex;
    align-items: center;

    // 图片
    .img-block {
      width: 800px;
      height: 500px;
      position: relative;
      // 左边图片
      .img-left {
        position: absolute;
        left: 272px;
        // top: 334px;
        bottom: 277px;
        width: 140px;
        display: flex;
        .item-left-two {
          position: relative;
          right: -8px;
          top: -54px;
          img:nth-child(1) {
            animation: imgLeftDown 6s linear infinite;
          }
          img:nth-child(2) {
            animation: imgScale 5s linear infinite;
          }
        }
        .item-left-one {
          position: relative;
          right: 0px;
          top: -19px;
          img:nth-child(1) {
            animation: imgLeftDown 4s linear infinite;
          }
          img:nth-child(2) {
            animation: imgScale 5s linear infinite;
          }
        }
      }
      // 中间图片
      .img-center {
        position: absolute;
        width: 285px;
        // top: 203px;
        bottom: 497px;
        right: 45px;
        img {
          transform: translateX(15px);
          position: absolute;
        }
        img:nth-child(1) {
          top: 50px;
          right: 232px;
          animation: imgCenterDown 8s linear infinite reverse;
        }
        img:nth-child(2) {
          top: 58px;
          right: 211px;
          animation: imgCenterDown 8s linear infinite;
        }
        img:nth-child(3) {
          top: 72px;
          right: 193px;
          animation: imgCenterDown 8s linear infinite reverse;
        }
        img:nth-child(4) {
          top: 150px;
          right: 155px;
          animation: imgCenterDown 6s linear infinite;
        }
      }
      //右边图片
      .img-right {
        position: absolute;
        right: 203px;
        // top: 209px;
        bottom: 484px;
        img:nth-child(1) {
          animation: imgRight 6s linear infinite;
          right: 18px;
          position: relative;
        }
        img:nth-child(2) {
          position: absolute;
          top: 94px;
          right: -69px;
          animation: imgRight 5s linear infinite;
        }
      }
    }

    // 表单
    .form-block {
      width: 450px;
      min-height: 500px;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 8px;
      border: 1px solid #ffffff;
      backdrop-filter: blur(3px);
      margin-left: 20px;
      .form-img-box {
        width: 280px;
        height: 56px;
        margin: 0 auto;
        margin-top: 30px;
        img {
          width: 100%;
        }
      }

      .tab-block {
        display: block;
        margin-top: 42px;
        .tab-item {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #8c8c8c;
          display: flex;
          padding: 0 60px;
          box-sizing: border-box;
          span {
            cursor: pointer;
            width: 80px;
            display: inline-block;
          }
          span:nth-child(2) {
            margin-left: 56px;
          }
        }

        .activeName {
          color: #272727;
          &:after {
            width: 80px;
            height: 4px;
            background: #1a85ff;
            border-radius: 4px;
            display: block;
            content: " ";
            margin-top: 12px;
          }
        }
      }

      .form-con {
        margin-top: 22px;
        padding: 0 45px;
        .icon-block {
          width: 37px;
          height: 37px;
          background: #fafafa;
          border-radius: 4px 0px 0px 4px;
          position: relative;
          left: -4px;
          top: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            position: relative;
            width: 16px;
            height: 16px;
          }
        }
      }

      .login-btn {
        width: 360px;
        height: 40px;
        margin-top: 40px;
        margin-bottom: 64px;
        background: $button-confirm-color;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        outline: none;
        line-height: 40px;
      }

      .face-density-btn {
        width: 360px;
        height: 40px;
        margin-bottom: 64px;
        background: $button-confirm-color;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        outline: none;
        margin-top: 25px;
      }

      // 免密登陆
      .form-item-password {
        .el-form-item__content {
          display: flex;
          justify-content: space-between;
        }
      }
      .form-item-password {
        .password-block {
          height: 40px;
          width: 256px;
        }
      }
    }

    // Copyright
    .copyright-block {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #8c8c8c;
      line-height: 20px;
      text-align: center;
      margin-bottom: 24px;
      z-index: 1000;
    }

    .btnHeight40 {
      height: 40px;
      line-height: 40px;
      margin-left: 10px;
    }
  }
}

// 动画 -- 左边图片 & 投影动画
@keyframes imgLeftDown {
  25% {
    transform: translateY(6px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(-6px);
  }
}

// 图片放大
@keyframes imgScale {
  25% {
    transform: scaleX(1.3);
  }

  50%,
  100% {
    transform: scaleX(1);
  }

  75% {
    transform: scaleX(1.3);
  }
}

// 中间模块图片动画
@keyframes imgCenterDown {
  25% {
    transform: translate(15px, 6px);
  }

  50%,
  100% {
    transform: translate(15px, 0);
  }

  75% {
    transform: translate(15px, -6px);
  }
}

// 右边模块图片动画

@keyframes imgRight {
  25% {
    transform: translateY(10px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(-10px);
  }
}

#captcha {
  width: 358px;
  margin-bottom: 22px;
}

#captchaAccountNumber {
  width: 358px;
  margin-bottom: 22px;
}

.find-password {
  text-align: right;
  color: #1985ff;
  margin-top: -10px;
  .btnNoBordeShortrBlue {
    text-decoration: none;
    height: 24px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue